import notify from 'lib/notify';
import getSubscriptionId from 'lib/getSubscriptionId';

const AUTH_TOKEN_KEY = 'bf_auth_token';

const postRequestHeaders = {
  method: 'POST',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
};

const getRequestHeaders = {
  headers: {
    Accept: 'application/json'
  }
};

export async function fetchAuthToken() {
  const res = await fetch(window.API_HOST + '/api/auth/token', {
    ...postRequestHeaders,
    body: JSON.stringify({ subscription_id: getSubscriptionId() })
  });
  const { token } = await res.json();
  return token;
}

export async function fetchServiceAreaPostcodes() {
  return await request('/api/service_area_postcodes.json', getRequestHeaders);
}

export async function fetchServiceSettings() {
  return await request('/api/service_settings.json', getRequestHeaders);
}

export async function fetchProducts(size) {
  return await request(
    `/api/flip/products?inchSize=${size}`,
    getRequestHeaders
  );
}

export async function fetchSubscription(id) {
  return await request(
    `/api/firmhouse/subscriptions?subscription_id=${id}`,
    getRequestHeaders
  );
}

export async function fetchRepairForm() {
  return await request(`/api/repair_requests/form.json`, getRequestHeaders);
}

export async function fetchPendingReturns(id) {
  return await request(
    `/api/firmhouse/pending_returns?subscription_id=${id}`,
    getRequestHeaders
  );
}

export async function requestFlip(body) {
  return await request('/api/flip', {
    ...postRequestHeaders,
    body: JSON.stringify(body)
  });
}

export async function requestRepair(body) {
  return await request('/api/repair_requests.json', {
    ...postRequestHeaders,
    body: JSON.stringify(body)
  });
}

export async function addBike(body) {
  return await request('/api/firmhouse/add', {
    ...postRequestHeaders,
    body: JSON.stringify(body)
  });
}

export async function returnBike(body) {
  return await request('/api/firmhouse/return', {
    ...postRequestHeaders,
    body: JSON.stringify(body)
  });
}

export async function updateExtraFields(body) {
  return await request('/api/firmhouse/update_extra_fields', {
    ...postRequestHeaders,
    body: JSON.stringify(body)
  });
}

export async function sendFeedback(body) {
  return await request('/api/feedbacks', {
    ...postRequestHeaders,
    body: JSON.stringify(body)
  });
}

export async function sendInvoiceCancellationPickup(body) {
  return await request('/api/firmhouse/invoice_cancellation_pickup', {
    ...postRequestHeaders,
    body: JSON.stringify(body)
  });
}

export async function cancelSubscription({ id, ...body }) {
  return await request(`/api/subscriptions/${id}`, {
    ...postRequestHeaders,
    method: 'DELETE',
    body: JSON.stringify(body)
  });
}

// @todo remove this
export async function updateAddress(body) {
  return await request('/api/flip/update_address', {
    ...postRequestHeaders,
    body: JSON.stringify(body)
  });
}

export async function submitDonation(body) {
  const url = window.location.hostname.includes('localhost')
    ? import.meta.env.VITE_DONATION_URL
    : 'https://eo7fjib8wrbghw.m.pipedream.net';
  const response = await fetch(url, {
    ...postRequestHeaders,
    mode: 'cors',
    body: JSON.stringify(body)
  });
  if (!response.ok) {
    throw new Error(`HTTP Error: ${response.status}`);
  }
  return await response.json();
}

export async function beyondClosingHours(body) {
  const response = await fetch(
    window.API_HOST + '/api/firmhouse/closing_hours_check',
    {
      ...postRequestHeaders,
      body: JSON.stringify({ firmhouse: body })
    }
  );
  if (!response.ok) {
    const res = await response.json();
    alert(res.message);
    return true;
  }
  return false;
}

async function request(endpoint, options = {}) {
  try {
    options.headers = options.headers || {};

    // always use the latest token
    options.headers['Authorization'] = `Bearer ${getLocalToken()}`;

    const response = await fetch(window.API_HOST + endpoint, options);

    // if unauthorized, retrieve new token and repeat the requst
    if (response.status === 401 && !options._retried) {
      const token = await fetchAuthToken();
      setLocalToken(token);

      return request(endpoint, {
        ...options,
        _retried: true // prevent infinite loop
      });
    }

    if (!response.ok) {
      throw new Error(`HTTP Error: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error('Error making request:', error);
    notify(error);
  }
}

// Set token locally
export function setLocalToken(value) {
  localStorage.setItem(AUTH_TOKEN_KEY, value);
}

// Get token locally
export function getLocalToken() {
  return localStorage.getItem(AUTH_TOKEN_KEY);
}
